/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type USER_ROLE = "ADMIN" | "COMMENTER" | "MEMBER" | "MODERATOR" | "STAFF" | "%future added value";
export type ModerateStoryButton_viewer = {
    readonly role: USER_ROLE;
    readonly " $refType": "ModerateStoryButton_viewer";
};
export type ModerateStoryButton_viewer$data = ModerateStoryButton_viewer;
export type ModerateStoryButton_viewer$key = {
    readonly " $data"?: ModerateStoryButton_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ModerateStoryButton_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ModerateStoryButton_viewer",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "role",
            "storageKey": null
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = '0ed325325508e8f54c658752732d7389';
export default node;
